import libs from '../../libs'

const state = {
  zones: {
    offset: 0,
    limit: 10,
    data: [],
    total: 0
  }
}

const getters = {
  zones: (state) => state.zones
}

const actions = {
  toLoadZones: async function ({ commit }, query = {}) {
    commit('setLoading', 'memuat daftar zona')

    const newQuery = libs.generateQuery(query, {
      offset: typeof query.offset !== 'undefined' ? query.offset : state.zones.offset,
      limit: typeof query.limit !== 'undefined' ? query.limit :  state.zones.limit
    })

    const listUserRoles = await this.dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/zones?${newQuery.toString}`
    })

    if (listUserRoles) {
      commit('setZones', {
        offset: typeof newQuery.offset !== 'undefined' ? newQuery.offset : state.zones.offset,
        limit: typeof newQuery.limit !== 'undefined' ? newQuery.limit :  state.zones.limit,
        data: listUserRoles.data.zones,
        total: listUserRoles.data.total
      })
    }

    commit('unsetLoading')
  },
  toDeleteZone: async function ({ commit, dispatch }, zoneId) {
    commit('setLoading', 'menghapus zona')

    await dispatch('authenticatedApi', {
      method: 'delete',
      url: `${window.config.BASEURL_API1}/zone/${zoneId}`
    })

    commit('unsetLoading')
  }
}

const mutations = {
  setZones: (state, zones) => state.zones = zones
}

export default {
  state,
  getters,
  actions,
  mutations
}
